import { type PageEntity, apiClient, type SubPartnerExEntity } from '@/libs/api'
import { type SubPartnersRequestQuery } from '@/libs/api/types'

export type FetchSubPartnersQuery = {
  tenantKey: string
  query?: SubPartnersRequestQuery
}

export type FetchSubPartnersResponse = {
  data: SubPartnerExEntity[]
  pagination: PageEntity | null
}

export const fetchSubPartners = async (
  { tenantKey, query }: FetchSubPartnersQuery,
  signal?: AbortSignal
): Promise<FetchSubPartnersResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .sub_partners.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
